export default __webpack_public_path__ + "static/media/bankist_app.90163218.png";